import apiService from "./apiService";

const signatureService = {
    async search(model) {
        try {
            const resp = await apiService.get(`signatures/search`, model, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async save(signature) {
        try {
            const resp = await apiService.post(`signatures/save`, signature, true);
            return resp.data;
        }
        catch (error) {
            console.error("save-signature", error)
            return { succes: false, message: "An error occured while processing the request" };
        }
    },
    async getInfo(id){
        try{
            const resp = await apiService.get(`signatures/${id}/get-info`,{},true);
            return resp.data;
        }
        catch(error){
            console.error('get-info',error);
            return {};
        }
    },
    async getSignatoriesByCode(code){
        try{
            const resp = await apiService.get(`signatures/${code}/get-signatories`,{},true);
            return resp.data;
        }
        catch{
            return [];
        }
    },
    async deleteSignature(id){
        try{
            const resp = await apiService.delete(`signatures/${id}/delete`,true);
            return resp.data;
        }
        catch{
            return {success: false, message: "An error occured while processing the request."}
        }
    }
}

export default signatureService;